export const normalizePreferences = (value = {}) => ({
  theme: value.theme === "dark" ? "dark" : "light",
  language: value.language || "en",
  timezone: value.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC",
  dateFormat: value.dateFormat || value.date_format || "YYYY-MM-DD",
  timeFormat24h: value.timeFormat24h ?? value.time_format_24h ?? true,
});

export const preferencePayload = (value) => ({
  theme: value.theme,
  language: value.language,
  timezone: value.timezone,
  dateFormat: value.dateFormat,
  timeFormat24h: value.timeFormat24h,
});

export const applyThemePreference = (theme) => {
  const selected = theme === "dark" ? "dark" : "light";
  localStorage.setItem("theme", selected);
  localStorage.setItem("theme_source", "manual");
  localStorage.setItem("darkMode", String(selected === "dark"));
  document.documentElement.classList.toggle("dark", selected === "dark");
  window.dispatchEvent(new CustomEvent("akkorent:theme", { detail: selected }));
};

export const formatDateTime = (value, preferences) => {
  if (!value) return "Unknown";
  const date = new Date(value);
  const dateFormat = preferences.dateFormat === "MM/DD/YYYY" ? "en-US" : "en-GB";
  return date.toLocaleString(dateFormat, {
    year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit",
    hour12: !preferences.timeFormat24h,
    timeZone: preferences.timezone,
  });
};
